// sections
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { TopCustomObject } from '../../../modules/Accounts';
import useAccountDetail from '../../AccountDetail/useAccountDetail';
import { getCustomObjects, getCustomObjectPinningData } from '../../../features';
import useToggle from '../../../hooks/useToggle';

export default function CustomTopObjectsTable({ selectedFilters, permissions }) {
  const [refreshCustomObjHandler, setRefreshCustomObjHandler] = useToggle();
  const dispatch = useDispatch();

  useEffect(() => {
    let filter = { type: 'all' };
    if (selectedFilters.account) {
      filter = { ...filter, ...{ type: 'account', accountId: selectedFilters.account.value } };
    }
    if (selectedFilters.timeFrame) {
      filter = { ...filter, ...{ view: selectedFilters.timeFrame } };
    }
    dispatch(getCustomObjects(filter));
    dispatch(getCustomObjectPinningData());
  }, [refreshCustomObjHandler, selectedFilters]);

  const { customObject, customObjectPinningData } = useAccountDetail();

  return <Box>{customObject && <TopCustomObject selectedFilters={selectedFilters} permissions={permissions} setRefreshCustomObjHandler={setRefreshCustomObjHandler} customObject={customObject} customObjectPinningData={customObjectPinningData} pageSize={15} />}</Box>;
}
